const data = [
    {
        id:1,
        url:'/images/tiktok-firebase.png',
        title:'Tiktok Clone using Firebase',
    },
    {
        id:2,
        url:'/images/tiktok-mern.png',
        title:'Tiktok Clone using MERN Stack',
    },
    {
        id:3,
        url:'/images/whatsapp-firebase.png',
        title:'Whatsapp Clone using Firebase',
    },
    {
        id:4,
        url:'/images/whatsapp-mern.png',
        title:'WhatsApp Clone using MERN Stack',
    },
    {
        id:5,
        url:'/images/dijkstra.png',
        title:'Pathfinding using Dijkstra algorithm',
    },
    {
        id:6,
        url:'/images/chain-reaction.png',
        title:'Chain Reaction Game',
    },
    {
        id:7,
        url:'/images/dfs.png',
        title:'Pathfinding using Dfs algorithm',
    }
]

export default data;